webpackJsonp([146520050992020],{

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _VasudhaAsher = __webpack_require__(929);
	
	var _VasudhaAsher2 = _interopRequireDefault(_VasudhaAsher);
	
	var _AnahitaMedhora = __webpack_require__(910);
	
	var _AnahitaMedhora2 = _interopRequireDefault(_AnahitaMedhora);
	
	var _AnshulJain = __webpack_require__(911);
	
	var _AnshulJain2 = _interopRequireDefault(_AnshulJain);
	
	var _IpsitaChowdhury = __webpack_require__(917);
	
	var _IpsitaChowdhury2 = _interopRequireDefault(_IpsitaChowdhury);
	
	var _AshaKrishnan = __webpack_require__(913);
	
	var _AshaKrishnan2 = _interopRequireDefault(_AshaKrishnan);
	
	var _Jolly_Abraham = __webpack_require__(918);
	
	var _Jolly_Abraham2 = _interopRequireDefault(_Jolly_Abraham);
	
	var _Harjot_Dhaliwal = __webpack_require__(915);
	
	var _Harjot_Dhaliwal2 = _interopRequireDefault(_Harjot_Dhaliwal);
	
	var _NidhiPrabhakarGhuman = __webpack_require__(920);
	
	var _NidhiPrabhakarGhuman2 = _interopRequireDefault(_NidhiPrabhakarGhuman);
	
	var _Ruchi_Khajanchi_new = __webpack_require__(924);
	
	var _Ruchi_Khajanchi_new2 = _interopRequireDefault(_Ruchi_Khajanchi_new);
	
	var _FatimaSami = __webpack_require__(914);
	
	var _FatimaSami2 = _interopRequireDefault(_FatimaSami);
	
	var _Mahua_Roy = __webpack_require__(919);
	
	var _Mahua_Roy2 = _interopRequireDefault(_Mahua_Roy);
	
	var _Sakshi_Chopra = __webpack_require__(925);
	
	var _Sakshi_Chopra2 = _interopRequireDefault(_Sakshi_Chopra);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mentConstant = [{
	  imgUrl: _AnahitaMedhora2.default,
	  name: "Anahita Medhora",
	  oldpost: "Managing Director\n",
	  oldcompany: "Everstone Group",
	  newpost: "Vice President \n",
	  newcompany: "Everstone Capital",
	  linkedIn: "https://www.linkedin.com/in/anahitamedhora/"
	}, {
	  imgUrl: _AnshulJain2.default,
	  name: "Anshul Jain",
	  oldpost: "Managing Director\n",
	  oldcompany: "Lighthouse Funds",
	  newpost: "Managing Director\n",
	  newcompany: "Lighthouse Advisors",
	  linkedIn: "https://www.linkedin.com/in/anshul-jain-3584321/"
	}, { imgUrl: _AshaKrishnan2.default,
	  name: "Asha Krishnan",
	  oldpost: "Vice President\n",
	  oldcompany: "General Atlantic",
	  newpost: "Operating Director\n",
	  newcompany: "General Atlantic",
	  linkedIn: "https://www.linkedin.com/in/asha-krishnan-7332b79/"
	}, { imgUrl: _FatimaSami2.default,
	  name: "Fatima Sami",
	  oldpost: "Director\n",
	  oldcompany: "Unilever",
	  newpost: "CFO\n",
	  newcompany: "Hector Beverages",
	  linkedIn: "https://www.linkedin.com/in/fatima-sami-78ab0819/"
	}, { imgUrl: _Harjot_Dhaliwal2.default,
	  name: "Harjot Dhaliwal",
	  oldpost: "Partner, Head of India\n",
	  oldcompany: "Apax Partners",
	  newpost: "Principal\n",
	  newcompany: "Apax Partners",
	  linkedIn: "https://www.linkedin.com/in/harjot-dhaliwal-691a6517/"
	}, { imgUrl: _IpsitaChowdhury2.default,
	  name: "Ipsita Chowdhury",
	  oldpost: "Associate General Counsel\n",
	  oldcompany: "Blinkit",
	  newpost: "Counsel\n",
	  newcompany: "Trilegal",
	  linkedIn: "https://www.linkedin.com/in/ipsita-chowdhury-8a408919/"
	}, { imgUrl: _Jolly_Abraham2.default,
	  name: "Jolly Abraham",
	  oldpost: "Managing Director and General Counsel\n",
	  oldcompany: "True North",
	  newpost: "Director\n",
	  newcompany: "True North",
	  linkedIn: "https://www.linkedin.com/in/jolly-abraham-5b5a0613/"
	}, { imgUrl: _Mahua_Roy2.default,
	  name: "Mahua Roy",
	  oldpost: "AVP Business Finance\n",
	  oldcompany: "Ecom Express",
	  newpost: "Deputy General Manager\nCommercial Finance\n",
	  newcompany: "Ecom Express",
	  linkedIn: "https://www.linkedin.com/in/mahua-roy-7a991348/"
	}, { imgUrl: _NidhiPrabhakarGhuman2.default,
	  name: "Nidhi Prabhakar Ghuman",
	  oldpost: "Managing Partner\n ",
	  oldcompany: "Vincere Partners",
	  newpost: "Principal\n",
	  newcompany: "Multiples Alternate Asset Management",
	  linkedIn: "https://www.linkedin.com/in/nidhiprabhakarghuman/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
	}, { imgUrl: _Ruchi_Khajanchi_new2.default,
	  name: "Ruchi Khajanchi",
	  oldpost: "CFO \n",
	  oldcompany: "A91 Partners",
	  newpost: "-",
	  newcompany: "-",
	  linkedIn: "https://www.linkedin.com/in/ruchi-khajanchi-7845028/"
	}, { imgUrl: _Sakshi_Chopra2.default,
	  name: "Sakshi Chopra",
	  oldpost: "Managing Director\n",
	  oldcompany: "Peak XV Partners",
	  newpost: "Principal\n",
	  newcompany: "Sequoia Capital",
	  linkedIn: "https://www.linkedin.com/in/sakshi-chopra-4aa1881/"
	}, { imgUrl: _VasudhaAsher2.default,
	  name: "Vasudha Asher",
	  oldpost: "Partner\n",
	  oldcompany: "AZB & Partners",
	  newpost: "Senior Associate\n",
	  newcompany: "AZB & Partners",
	  linkedIn: "https://www.linkedin.com/in/vasudha-asher-86a40722/"
	}];
	
	exports.default = mentConstant;
	module.exports = exports["default"];

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Anahita-Medhora.dafc6041.jpg";

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Anshul-Jain.3e371d68.jpg";

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Asha-Krishnan.5264cccb.jpg";

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Fatima-Sami.c71c733d.jpg";

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Harjot_Dhaliwal.f611e09b.jpg";

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ipsita-Chowdhury.6351c82c.jpg";

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Jolly_Abraham.c64b54cc.jpg";

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mahua_Roy.bbdf2882.jpg";

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Nidhi-Prabhakar-Ghuman.ac9f671b.jpg";

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ruchi_Khajanchi_new.736f076b.jpg";

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Sakshi_Chopra.cd44957b.jpg";

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Vasudha-Asher.b9a744e6.jpg";

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(586);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentConstant = __webpack_require__(396);
	
	var _mentConstant2 = _interopRequireDefault(_mentConstant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'head_section' },
	        _react2.default.createElement(
	          'span',
	          { className: 'item_name' },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.post
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.company
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'cross pull-right' },
	        _react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'item__desc force-overflow' },
	        _react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var Index = exports.Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index(args) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false
	    };
	
	    return _this;
	  }
	
	  Index.prototype.render = function render() {
	    var location = this.props.location;
	    var isShow = this.state.isShow;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentees: Cohort of 2020', description: 'A group of highly talented young women on their path to continued success.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mentees-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Mentees ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' '
	              ),
	              ' Cohort I'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section_intro_text' },
	            'A group of highly talented young women on their path to continued success.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _mentConstant2.default.map(function (item, i) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-md-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner' },
	                    _react2.default.createElement('img', { className: 'imagess', src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Previous Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.oldpost,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.oldcompany,
	                        ' '
	                      ),
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Current Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.newpost,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.newcompany,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Index;

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-winpementees-index-js-5874e7699b92bdbb4833.js